module.exports = __webpack_public_path__ + "img/bg.c355cd41.png";